<template>
  <div>
    <div class="login-container">
      <div class="page-step" v-if="active !== -1">
        <!-- 步骤条 -->
        <div class="step-wrapper">
          <div class="step-item" v-for="(step, index) in steps" :key="index">
            <div class="step-circle" :class="getStepClass(index)">{{ index + 1 }}</div>
            <div class="step-text" :class="getStepClass(index)">
              <div class="cn">{{ step.cn }}</div>
              <div class="en">{{ step.en }}</div>
            </div>
            <div class="step-line" v-if="index < steps.length - 1" :class="{ 'line-done': index < active }"></div>
          </div>
        </div>
      </div>
      <div class="center">
        <div class="steps">
          <div class="back" @click="goBack">返回</div>
          <div class="course-class-topback">
            <img
              class="course-left-backimg"
              src="https://cdn.spbcn.org/spbcnWeb/pbl/logo.png"
            />
            <div class="course-title">
              <div class="cn">{{ active === -1 ? '报名信息' : '组队报名'}}</div>
              <div class="en">{{ active === -1 ? 'Registration Information' : 'Team Registration'}}</div>
            </div>
          </div>
          <div class="step-bar">
            <div class="">
              <el-form
                :model="formData"
                :rules="formRules"
                ref="schoolRegistRuleFormRef"
                label-width="80px"
                style=" margin-top: 20px"
              >
                <div class="card" v-if="active === 1 || active === -1 || uploadFile">
                  <div class="title">项目信息</div>
                  <div class="en-title">Project Information</div>
                  <el-row>
                    <el-col :span="10">
                      <div class="item">
                        <div class="key">项目领域</div>
                        <div class="val val1">
                          <div class="cn">{{ val }}</div>
                          <div class="en">{{ enval }}</div>
                        </div>
                      </div>
                      <div class="item">
                        <div class="key">项目方向</div>
                        <div class="val val2">
                          <div class="cn">{{ theme }}</div>
                          <div class="en">{{ entheme }}</div>
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="14">
                      <!-- <el-form-item label="项目主题" v-if="isEdit">
                        {{ theme }}
                      </el-form-item> -->
                      <el-form-item label="项目方向" v-if="customize === '1'" prop="theme">
                        <el-input
                          :disabled="active === -1 || uploadFile !== 0"
                          v-model="formData.theme"
                          placeholder="请输入"
                          clearable
                        ></el-input>
                      </el-form-item>
                      <el-form-item label="项目名称" prop="name">
                        <el-input
                          :disabled="active === -1 || uploadFile !== 0"
                          v-model="formData.name"
                          placeholder="请输入"
                          clearable
                        ></el-input>
                      </el-form-item>
                      <el-form-item label="项目简介" prop="introduction">
                        <el-input
                          :disabled="active === -1 || uploadFile !== 0"
                          v-model="formData.introduction"
                          type="textarea"
                          :rows="5"
                          placeholder="请输入"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
                <div class="card mt-30" v-if="active === 1 || active === -1 || uploadFile">
                  <div class="title">战队信息</div>
                  <div class="en-title">Team Information</div>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <div class="item2">
                        <div class="key">学校名称</div>
                        <div class="val">{{ schoolName }}</div>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="item2">
                        <div class="key">学校地址</div>
                        <div class="val">{{ address }}</div>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="战队名称" prop="teamName">
                        <el-input :disabled="active === -1 || uploadFile !== 0" v-model="formData.teamName"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="战队组别" prop="schoolLevel">
                        <el-select
                          :disabled="active === -1 || uploadFile !== 0"
                          v-model="formData.schoolLevel"
                          placeholder="请选择战队组别"
                          style="width: 100%"
                        >
                          <el-option
                            v-for="item in dict_schoolGroup"
                            :key="item.dictCode"
                            :label="item.dictLabel"
                            :value="item.dictValue"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
                <div class="card mt-30" v-if="active === 3 || active === -1 || uploadFile">
                  <div class="title">教师信息</div>
                  <div class="en-title">Teacher Information</div>
                  <el-row :gutter="10">
                    <el-col :span="12" v-for="(teamItem, index) in formData2.teachers" :key="index">
                      <div class="user-card">
                        <div class="user-card-title">
                          <i class="el-icon-remove remove" v-if="formData2.teachers.length > 1 && index !== 0" @click="removeItem2(index)"></i>
                          <img :src="$env.imgUrl + 'icon-user.png'" alt="">
                          老师{{ index+1 }}
                        </div>
                        <el-row class="pr-20">
                          <el-col :span="12">
                            <el-form-item label="姓名">
                              <el-input :disabled="active === -1 || uploadFile !== 0" v-model="teamItem.userName"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="性别">
                              <el-select
                                :disabled="active === -1"
                                placeholder="请选择"
                                style="width: 100%"
                                v-model="teamItem.sex"
                              >
                                <el-option label="男" value="2"></el-option>
                                <el-option label="女" value="1"></el-option>
                              </el-select>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="手机号">
                              <el-input :disabled="active === -1 || uploadFile !== 0" v-model="teamItem.phone"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="职位">
                              <el-input :disabled="active === -1 || uploadFile !== 0" v-model="teamItem.position"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="24">
                            <el-form-item label="邮箱">
                              <el-input :disabled="active === -1 || uploadFile !== 0" v-model="teamItem.email"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </div>
                    </el-col>
                    <el-col :span="12" class="operate" v-if="active !== -1 && !uploadFile">
                      <div class="add-btn" @click="addItem2">
                        <img :src="$env.imgUrl + 'add.png'" alt="">
                      </div>
                    </el-col>
                  </el-row>
                  <div class="default" v-if="!formData2.teachers.length">
                    暂无教师信息
                  </div>
                  <div class="title mt-30">队员信息</div>
                  <div class="en-title">Team Member Information</div>
                  <el-row :gutter="10">
                    <el-col :span="12" v-for="(teamItem, index) in formData2.students" :key="index">
                      <div class="user-card">
                        <div class="user-card-title">
                          <i class="el-icon-remove remove" v-if="formData2.students.length > 1 && !teamItem.paydStatus" @click="removeItem(index)"></i>
                          <img :src="$env.imgUrl + 'icon-user.png'" alt="">
                          队员{{ index+1 }}
                          <span v-if="teamItem.paydStatus">已缴费</span>
                        </div>
                        <el-row class="pr-20">
                          <el-col :span="12">
                            <el-form-item label="姓名">
                              <el-input :disabled="active === -1 || teamItem.paydStatus || uploadFile !== 0" v-model="teamItem.userName"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="性别">
                              <el-select :disabled="active === -1 || teamItem.paydStatus || uploadFile !== 0"
                                placeholder="请选择"
                                style="width: 100%"
                                v-model="teamItem.sex"
                              >
                                <el-option label="男" value="2"></el-option>
                                <el-option label="女" value="1"></el-option>
                              </el-select>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="年级">
                              <el-select :disabled="active === -1 || teamItem.paydStatus"
                                placeholder="请选择"
                                style="width: 100%"
                                v-model="teamItem.grade"
                              >
                                <el-option v-for="(grade, g) in dict_grade" :key="g" :label="grade.dictLabel" :value="grade.dictCode"></el-option>
                              </el-select>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="手机号">
                              <el-input :disabled="active === -1 || teamItem.paydStatus" v-model="teamItem.phone"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="24">
                            <el-form-item label="邮箱">
                              <el-input :disabled="active === -1 || teamItem.paydStatus" v-model="teamItem.email"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </div>
                    </el-col>
                    <el-col :span="12" class="operate" v-if="active !== -1 && !uploadFile">
                      <!-- <i class="el-icon-circle-plus" ></i> -->
                      <div class="add-btn" @click="addItem">
                        <img :src="$env.imgUrl + 'add.png'" alt="">
                      </div>
                    </el-col>
                  </el-row>
                  <div class="default" v-if="!formData2.students.length">
                    暂无队员信息
                  </div>
                </div>
                <div class="card mt-30" v-if="uploadFile || active === -1">
                  <div class="title">提交赛前资料</div>
                  <div class="en-title">Submit Pre-match Materials</div>
                  <div class="default" v-if="!haveFile">
                    暂未提交
                  </div>
                  <div v-else>
                    <div class="desc-title">请将资料打包成一个压缩包上传；上传成功后，点击图标可重新上传；点击文件名可下载文件。</div>
                    <el-row :gutter="10">
                      <el-col :span="6" v-for="(item, i) in fileTypeList" :key="i">
                        <div class="file-item-card">
                          <div class="tit">
                            <div class="cn">{{ item.cn }}</div>
                            <div class="en">{{ item.en }}</div>
                          </div>
                          <el-upload
                            :action="
                              uploadObj.uploadUrl
                            "
                            :disabled="active === -1"
                            class="file-upload"
                            :show-file-list="false"
                            :on-success="(res, file) => handleSuccess(res, file, i)"
                            :headers="
                              uploadObj.headerObj
                            "
                            :data="{
                              filePath: 'spbcnWeb/pbl/upload/preMatch/',
                            }"
                          >
                            <div class="upload-btn" v-if="!item.fileUrl">
                              <img :src="$env.imgUrl + 'add.png'" alt="">
                            </div>
                            <div class="file" v-else>
                              <img class="icon-file" :src="$env.imgUrl + 'icon-file.png'" alt="">
                              <div class="file-name" @click="openFile(item.fileUrl)">{{ item.fileName }}</div>
                            </div>
                          </el-upload>
                          <div class="desc">{{ item.desc }}</div>
                        </div>
                      </el-col>
                    </el-row>
                    <el-button type="primary" class="submit" @click="saveFiles" v-if="active !== -1">提 交</el-button>
                  </div>
                </div>
              </el-form>
              <el-button type="primary" class="submit" @click="next" v-if="active === 1">提交项目信息</el-button>
              <el-button type="primary" class="submit" @click="saveUsers" v-if="active === 3">保存战队信息</el-button>
            </div>

            <!-- 信息审核 -->
            <div v-if="active === 2">
              <div class="card mt-30">
                <div class="title">信息审核</div>
                <div class="en-title">Info review</div>
                <img class="info-check" :src="$env.imgUrl + 'icon-info.png'" alt="">
                <div class="tip">您的报名信息已成功提交，组委会将尽快进行审核，请您耐心等待结果通知。</div>
                <div class="entip">Your registration information has been successfully submitted. The organizing committee will review it as soon as possible. Please kindly wait for the notification of the results.</div>
              </div>
            </div>

            <!-- 支付 -->
            <div class="" v-if="active === 4">
              <div class="card" v-if="!havePayed">
                <div class="title">报名支付</div>
                <div class="en-title">Registration Payment</div>
                <div class="pay-tabs">
                  <div class="pay-tab-item" :class="payIndex === 0 ? 'active' : ''" @click="payFn(0)">团队在线支付</div>
                  <div class="pay-tab-item" :class="payIndex === 1 ? 'active' : ''" @click="payFn(1)">线下支付凭证</div>
                  <div class="pay-tab-item" :class="payIndex === 2 ? 'active' : ''" @click="payFn(2)">队员个人支付</div>
                  <div class="pay-tab-item" v-if="paydType === 4" :class="payIndex === 3 ? 'active' : ''" @click="payFn(3)">F码支付</div>
                </div>
                <div class="productName">{{ productName }}</div>
                <div v-if="payIndex === 0">
                  <div class="online-pay" v-if="qrImgSrc">
                    <div style="flex: 1; margin-right: 20px;">
                      <div class="productPrice">
                        <span>订单总价：</span>
                        <div>
                          ¥ {{ productPrice }}
                        </div>
                      </div>
                      <div class="expand-section">
                        <div class="expand-title">队员信息：</div>
                        <el-table
                          :data="students"
                          border
                          size="mini"
                          style="width: 100%"
                        >
                          <el-table-column label="#" type="index" width="60"></el-table-column>
                          <el-table-column label="姓名" prop="userName"></el-table-column>
                          <el-table-column label="性别" prop="sex" :formatter="sexFormat"></el-table-column>
                          <el-table-column label="年级" prop="grade" :formatter="gradeFormat"></el-table-column>
                          <el-table-column label="手机号" prop="phone"></el-table-column>
                          <el-table-column label="邮箱" prop="email"></el-table-column>
                          <el-table-column label="报名费">¥{{ fee }}</el-table-column>
                          <el-table-column label="支付状态" prop="paydStatus">
                            <template slot-scope="scope">
                              <el-tag :type="scope.row.paydStatus ? 'success' : 'danger'" size="mini" effect="dark">{{scope.row.paydStatus ? '已支付' : '未支付'}}</el-tag>
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>
                    </div>
                    <div class="pay-box">
                      <div class="scan">请使用微信扫码支付</div>
                      <img :src="qrImgSrc" class="qrCode" alt="">
                      <img class="wxzf" :src="$env.imgUrl + 'wxzf.png'" alt="">
                    </div>
                  </div>
                  <div v-else class="qrCodeLoading">
                    <i class="el-icon-loading"></i>
                    <div>正在生成订单</div>
                  </div>
                  <div class="btns">
                    <el-button class="btn1" @click="handleToCancelPay">取消支付</el-button>
                    <el-button class="btn2" @click="getPayResult">我已完成支付</el-button>
                    <!-- <el-button class="btn2" @click="showUpload">上传支付凭证</el-button> -->
                  </div>
                  <div class="pay-tip">在线支付支持微信支付，一次性支付团队总费用。</div>
                </div>
                <div class="" v-if="payIndex === 1">
                  <el-form class="offline-pay" :model="payForm" label-width="80px">
                    <el-form-item label="缴费凭证">
                      <el-upload
                      class="avatar-uploader"
                      :action="
                          uploadObj.uploadUrl
                      "
                      accept="image/*"
                      :show-file-list="false"
                      :on-success="uploadSuccess"
                      :headers="
                          uploadObj.headerObj
                      "
                      :before-upload="beforeUpload"
                      :data="{
                          filePath:
                              'spbcnWeb/pbl/upload/pay/',
                      }"
                  >
                      <img
                          v-if="payForm.payImageUrl"
                          class="img-detail"
                          :src="payForm.payImageUrl"
                      />
                      <i
                          v-else
                          class="el-icon-plus avatar-uploader-icon"
                      ></i>
                    </el-upload>
                    </el-form-item>
                    <el-form-item label="备注">
                      <el-input type="textarea" :rows="5" style="width: 80%;" v-model="payForm.payNote" placeholder="请备注支付金额等信息"></el-input>
                    </el-form-item>
                  </el-form>
                  <div class="btns">
                    <el-button class="btn2" @click="uploadFn">确认上传</el-button>
                  </div>
                  <div class="pay-tip">如已支付，请上传支付凭证。</div>
                </div>
                <div class="person-pay" v-if="payIndex === 2">
                  <div class="expand-section">
                    <div class="expand-title">队员信息：</div>
                    <el-table
                      :data="students"
                      border
                      size="mini"
                      style="width: 100%"
                    >
                      <el-table-column label="#" type="index" width="60"></el-table-column>
                      <el-table-column label="姓名" prop="userName"></el-table-column>
                      <el-table-column label="性别" prop="sex" :formatter="sexFormat"></el-table-column>
                      <el-table-column label="年级" prop="grade" :formatter="gradeFormat"></el-table-column>
                      <el-table-column label="手机号" prop="phone"></el-table-column>
                      <el-table-column label="邮箱" prop="email"></el-table-column>
                      <el-table-column label="报名费">¥{{ fee }}</el-table-column>
                      <el-table-column label="支付状态" prop="paydStatus">
                        <template slot-scope="scope">
                          <el-tag :type="scope.row.paydStatus ? 'success' : 'danger'" size="mini" effect="dark">{{scope.row.paydStatus ? '已支付' : '未支付'}}</el-tag>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>

                  <div class="btns">
                    <el-button class="btn2" @click="sendEmail">发送邮件</el-button>
                  </div>
                  <div class="pay-tip">系统分别向队员邮箱中发送支付链接，由队员自行支付参赛费用，请确保队员邮箱填写正确。</div>
                </div>
                <div class="" v-if="payIndex === 3">
                  <div class="text-c">请输入F码</div>
                  <div>
                    <el-input class="fcode-input" v-model="fcode"></el-input>
                  </div>
                  <div class="btns">
                    <el-button class="btn2" @click="submitFCode">确认提交</el-button>
                  </div>
                </div>
              </div>
            </div>

            <!-- 报名须知 -->
            <div class="card tips" v-if="active !== 2">
              <div class="title">报名须知</div>
              <div class="en-title">Registration Notice</div>
              一、注册报名时间<br/>
              2026年8月1日—9月30日<br/><br/>
              二、报名费用<br/>
              2680元/人<br/>
              （该费用仅为展演报名费，不包含食宿、交通及参赛期间的其他个人开支，相关费用需由参赛方自行承担。）<br/><br/>
              三、费用说明<br/>
              目前提供三种支付方式，请根据实际情况选择：<br/>
              团队支付：按队伍总人数自动生成总费用，由带队教师统一完成缴费。<br/>
              线下支付：请在相关页面上传付款凭证，经组委会审核通过后进入后续流程。<br/>
              个人支付：注册教师将通过系统向学生发送邮件，学生本人登录个人支付页面自行完成缴费。<br/><br/>
              四、活动时间<br/>
              2026年11月27日-11月29日（具体日期另行通知）<br/><br/>
              五、活动地点<br/>
              深圳<br/><br/>
              六、项目提报时间<br/>
              即日起至2026年9月30日截止<br/>
              注：提报展演项目需经组委会审核；每所学校可遴选多支队伍参赛，主题自选。<br/><br/>
              七、资料上传说明<br/>
              即日起至2026年10月30日截止<br/>
              注：四项展演作品材料须由指导教师按要求上传至教师端口，由组委会统一审核。<br/><br/>
              八、退费说明<br/>
              如因校方原因无故缺席展演，报名费一律不予退还。<br/>
              如因组委会原因导致展演未能成功举办，按实际已产生的必要费用扣除后，退还剩余部分。
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSchoolInfo, getSysUserInfo } from '@/http/api'

export default {
  data () {
    return {
      paydType: '',
      fcode: '',
      // schoolLevel: '',
      payIndex: 0,
      steps: [
        { cn: '选择方向', en: 'Select Field' },
        { cn: '项目立项', en: 'Project Initiation' },
        { cn: '信息审核', en: 'Info Review' },
        { cn: '组建战队', en: 'Build Team' },
        { cn: '报名支付', en: 'Register & Pay' },
        { cn: '提交赛前资料', en: 'Submit Pre-match Materials' }
      ],
      fileTypeList: [
        {
          cn: '项目路演',
          en: 'Project Pitch',
          desc: '1项目研究 PPT 完整版、2路演展示视频（可选）、3项目书（开题报告）',
          enDesc: '',
          fileUrl: '',
          fileName: ''
        },
        {
          cn: '宣传展板',
          en: 'Display Boards',
          desc: '1宣传展板高清设计源文件、2成品高清效果图',
          enDesc: '',
          fileUrl: '',
          fileName: ''
        },
        {
          cn: '工程作品',
          en: 'Project Portfolio',
          desc: '1原创工程作品实拍高清图集（不同方位3张及以上）、2作品设计说明',
          enDesc: '',
          fileUrl: '',
          fileName: ''
        },
        {
          cn: '主题舞台剧',
          en: 'Stage Play',
          desc: '1完整舞台剧剧本、2舞台剧设计说明（包括但不限于：节目与演员简介、舞台演绎素材说明与材料等）',
          enDesc: '',
          fileUrl: '',
          fileName: ''
        }
      ],
      haveFile: false,
      activityType: 3,
      active: 1,
      uploadFile: 0,
      dict_grade: this.$curUtils.getGradeData(),
      dict_schoolGroup: this.$curUtils.dict_schoolGroup(),
      students: [],
      fee: '',
      formData: {
        name: '',
        introduction: '',
        schoolId: '',
        theme: '',
        themeId: '',
        schoolLevel: '',
        teamName: ''
      },
      formData2: {
        students: [
          {
            userName: '',
            sex: '',
            phone: '',
            grade: '',
            email: ''
          },
          {
            userName: '',
            sex: '',
            phone: '',
            grade: '',
            email: ''
          }
        ],
        teachers: [
          {
            userName: '',
            sex: '',
            phone: '',
            position: '',
            email: ''
          }
        ]
      },
      formRules: {
        introduction: [{ required: true, message: '请输入', trigger: 'blur' }],
        name: [{ required: true, message: '请输入', trigger: 'blur' }],
        theme: [{ required: true, message: '请输入', trigger: 'blur' }],
        teamName: [{ required: true, message: '请输入', trigger: 'blur' }],
        schoolLevel: [{ required: true, message: '请选择', trigger: 'change' }]
      },
      havePayed: false,

      qrImgSrc: '',
      orderId: '',
      uploadObj: {
        uploadUrl: this.$env.baseIP + 'upload/uploadFileAliOss',
        headerObj: {
          Authorization: localStorage.getItem('HQAuthorization')
        }
      },
      payForm: {
        id: '',
        payImageUrl: '',
        payNote: ''
      },
      visible: false,
      theme: '',
      entheme: '',
      val: '',
      enval: '',
      schoolName: '',
      address: '',
      productPrice: '',
      productName: ''
    }
  },
  created () {
    if (this.$route.query.step) {
      this.active = Number(this.$route.query.step)
    }
    if (this.$route.query.uploadFile) { // 1上传 2修改
      this.uploadFile = Number(this.$route.query.uploadFile)
    }
    this.paydType = Number(this.$route.query.paydType)
    this.isEdit = this.$route.query.isEdit === '1'
    this.theme = this.$route.query.theme
    this.entheme = this.$route.query.entheme
    this.val = this.$route.query.val
    this.enval = this.$route.query.enval
    this.customize = this.$route.query.customize
    if (this.customize !== '1') {
      this.formData.theme = this.$route.query.theme
    }
    this.formData.themeId = this.$route.query.id
    this.pblTeamId = this.$route.query.pblTeamId
    // this.getSchoolInfo()
    this.getUserInfo()
    if (this.active === 4) {
      this.getQRCode()
    }
    if (this.$route.query.isEdit === '1' || this.active === -1 || this.uploadFile) {
      this.getDetail()
    }
    if (this.$route.query.isPay === '1') {
      this.getStudents()
    }
  },
  mounted () {
    // 绑定监听事件
    window.addEventListener('keydown', this.keyDown)
  },
  destroyed () {
    // 销毁事件
    window.removeEventListener('keydown', this.keyDown, false)
  },
  methods: {
    getStepClass (index) {
      if (index < this.active) return 'step-done'
      if (index === this.active) return 'step-active'
      return 'step-pending'
    },
    getDetail() {
      this.$http.get('pblTeam/info', { params: { id: this.pblTeamId } }).then(res => {
        if (res.code === 200) {
          this.formData.name = res.data.name
          this.formData.teamName = res.data.teamName
          this.formData.introduction = res.data.introduction
          this.formData.schoolId = res.data.schoolId
          this.formData.theme = res.data.theme.split('>')[1]
          this.theme = res.data.theme.split('>')[1]
          this.val = res.data.theme.split('>')[0]
          this.formData.themeId = res.data.themeId
          this.formData.schoolLevel = res.data.schoolLevel
          if (res.data.students) {
            this.formData2.students = res.data.students
          }
          if (res.data.teachers) {
            this.formData2.teachers = res.data.teachers
          }
          this.haveFile = !!res.data.file
          if (this.haveFile) {
            this.fileTypeList = JSON.parse(res.data.file)
          }
        }
      })
    },
    getStudents() {
      this.$http.get('pblTeam/info', { params: { id: this.pblTeamId } }).then(res => {
        if (res.code === 200) {
          this.students = res.data.students
        }
      })
    },
    showUpload () {
      this.payForm = {
        id: this.pblTeamId,
        payImageUrl: '',
        payNote: ''
      }
      this.visible = true
    },
    goBack () {
      this.$router.push(this.active === 1 ? '/club/home' : '/club/list')
    },
    // 获取学校信息
    getSchoolInfo (schoolId) {
      getSchoolInfo({ schoolId }).then((res) => {
        this.formData.schoolId = schoolId
        this.formData.schoolName = res.data.schoolName
      }).catch((err) => {
        console.log('返回的err', err)
      })
    },
    getUserInfo () {
      getSysUserInfo().then((res) => {
        // this.formData.schoolLevel = res.data.schoolTeacher.schoolLevel
        this.formData.schoolId = res.data.school.id
        this.address = res.data.school.province + res.data.school.city + res.data.school.area
        this.schoolName = res.data.school.schoolName
        // const arr = ['', '小学', '初中', '高中']
        // this.schoolLevel = arr[Number(this.formData.schoolLevel)]

        // 老师
        this.formData2.teachers[0].userName = res.data.sysUser.userName
        this.formData2.teachers[0].sex = res.data.sysUser.sex
        this.formData2.teachers[0].phone = res.data.sysUser.phone
        this.formData2.teachers[0].position = res.data.schoolTeacher.position
        this.formData2.teachers[0].email = res.data.sysUser.email
      }).catch((err) => {
        console.log('返回的err', err)
      })
    },
    handleToIndex () {
      this.$router.push('/homeView')
    },
    // 点击回车键登录
    keyDown (e) {
      // 回车则执行登录方法 enter键的ASCII是13
      if (e.keyCode === 13) {
        // this.mainLogin() // 定义的登录方法
      }
    },
    beforeUpload (file) {
      const isLt5M = file.size / 1024 / 1024 < 5

      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 5MB!')
      }
      return isLt5M
    },
    uploadSuccess (res) {
      this.$set(this.payForm, 'payImageUrl', res.data)
    },
    handleSuccess (res, file, index) {
      this.fileTypeList[index].fileName = file.name
      this.fileTypeList[index].fileUrl = res.data
    },
    openFile (url) {
      window.open(url)
    },
    saveFiles () {
      const len = this.fileTypeList.filter(item => !item.fileUrl).length
      if (len === 4) {
        return this.$message.warning('请上传文件')
      }
      this.$http.post('pblTeam/updateFiles', { id: this.pblTeamId, file: JSON.stringify(this.fileTypeList) }).then(res => {
        if (res.code === 200) {
          this.$message.success('上传成功')
        }
      })
    },
    uploadFn () {
      this.$http.post('pblTeam/updatePaydVoucher', this.payForm).then(res => {
        if (res.code === 200) {
          this.$message.success('上传成功，请等待组委会确认')
          this.visible = false
          this.goBack()
        }
      })
    },
    next () {
      this.$refs.schoolRegistRuleFormRef.validate(async valid => {
        if (!valid) return
        if (this.isEdit) {
          this.$http.post('pblTeam/edit', { ...this.formData, ...{ id: this.pblTeamId } }).then(res => {
            if (res.code === 200) {
              this.$message.success('已提交')
              this.active = 2
              this.havePayed = false
              // this.getProductInfo()
            }
          })
        } else {
          this.$http.post('pblTeam/create', this.formData).then(res => {
            if (res.code === 200) {
              this.$message.success('已提交')
              this.active = 2
            }
          })
        }
      })
    },
    saveUsers () {
      const phoneReg = /^1[3-9]\d{9}$/
      const emailReg = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_-]+)(\.[a-zA-Z0-9_-]+)*\.([a-zA-Z]{2,})$/

      // 校验 teachers
      for (let i = 0; i < this.formData2.teachers.length; i++) {
        const t = this.formData2.teachers[i]
        if (!t.phone || !t.email) {
          return this.$message.warning(`请将老师${i + 1}的手机号和邮箱补充完整`)
        }
        if (!phoneReg.test(t.phone)) {
          return this.$message.warning(`老师${i + 1}的手机号格式不正确`)
        }
        if (!emailReg.test(t.email)) {
          return this.$message.warning(`老师${i + 1}的邮箱格式不正确`)
        }
      }

      // 校验 students
      const empty = this.formData2.students.find(item => !item.userName || !item.phone || !item.grade || !item.sex || !item.email)
      if (empty) {
        return this.$message.warning('请将学生信息补充完整')
      }
      for (let i = 0; i < this.formData2.students.length; i++) {
        const s = this.formData2.students[i]
        if (!phoneReg.test(s.phone)) {
          return this.$message.warning(`队员${i + 1}的手机号格式不正确`)
        }
        if (!emailReg.test(s.email)) {
          return this.$message.warning(`队员${i + 1}的邮箱格式不正确`)
        }
      }

      this.$http.post('pblTeam/editStudents', { ...this.formData2, ...{ id: this.pblTeamId } }).then(res => {
        if (res.code === 200) {
          this.$message.success('已提交')
          this.active = 4
          this.havePayed = false
          this.payIndex = 0
          this.getQRCode()
          this.students = this.formData2.students
        }
      })
    },

    createOrder (data) {
      const paramsData = {
        num: 1,
        orderSource: 2,
        payType: '微信',
        paymentAmount: data.tbProductDetails[0].price,
        productId: data.id,
        tbProductDetailId: data.tbProductDetails[0].id,
        pblTeamId: this.pblTeamId
      }
      this.$http.post('order/creatTbProductOrder', paramsData).then(res => {
        if (res.data) {
          this.qrImgSrc = res.data.qcPicCode
          this.orderId = res.data.orderId
          this.productPrice = res.data.productPrice
          this.productName = res.data.productName
        }
      })
    },
    getPayResult () {
      this.$http.post('order/getTbProductOrderIsFinish', { id: this.orderId }).then(res => {
        if (res.code === 200) {
          this.$message.success('支付成功')
          this.handleToCancelPay()
        } else {
          this.$confirm('系统检测到订单未支付成功', '提示', {
            confirmButtonText: '重新支付',
            cancelButtonText: '取消支付',
            type: 'warning'
          }).then(() => {

          }).catch(() => {
            this.handleToCancelPay()
          })
        }
      })
    },
    handleToCancelPay () {
      this.$router.push('/club/list')
    },
    getQRCode() {
      this.$http.get('product/getTbProductByFlag', { params: { flag: 'PBL_TEAM', pblTeamId: this.pblTeamId } }).then(res => {
        if (res.code === 200) {
          this.createOrder(res.data)
          this.fee = res.data.tbProductDetails[0].price
        }
      })
    },
    addItem () {
      this.formData2.students.push({
        userName: '',
        sex: '',
        phone: '',
        grade: '',
        email: ''
      })
      this.calcTeamNum()
    },
    removeItem (i) {
      this.formData2.students.splice(i, 1)
      this.calcTeamNum()
    },
    calcTeamNum () {
      this.formData.teamNum = this.formData2.students.length
    },
    addItem2 () {
      this.formData2.teachers.push({
        userName: '',
        sex: '',
        phone: '',
        position: '',
        email: ''
      })
    },
    removeItem2 (i) {
      this.formData2.teachers.splice(i, 1)
    },
    payFn (index) {
      this.payIndex = index
      if (index === 1) {
        this.payForm = {
          id: this.pblTeamId,
          payImageUrl: '',
          payNote: ''
        }
      }
    },
    sexFormat (data) {
      return Number(data.sex) === 1 ? '女' : Number(data.sex) === 2 ? '男' : ''
    },
    gradeFormat (data) {
      return this.dict_grade.find(item => item.dictCode === data.grade).dictLabel
    },
    sendEmail () {
      this.$http.post('pblTeam/updatePayType', { id: this.pblTeamId, payType: 2 }).then(res => {
        if (res.code === 200) {
          this.$message.success('邮件已发送，请注意查收。')
          this.handleToCancelPay()
        }
      })
    },
    submitFCode () {
      if (!this.fcode) return
      this.$http.post('pblTeam/updatePayType', { id: this.pblTeamId, payType: 4, fcode: this.fcode }).then(res => {
        if (res.code === 200) {
          this.$message.success('支付成功')
          this.handleToCancelPay()
        }
      })
    }

  }
}
</script>

<style lang="less" scoped>
.pay-tabs{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  background-color: rgba(201, 39, 58, .1);
  .pay-tab-item{
    width: 200px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    font-family: systm;
    font-size: 14px;
    color: #999;
    border-bottom: 3px solid transparent;
    cursor: pointer;
    &.active{
      border-bottom-color: #b81c25;
      color: #b81c25;
      font-family: systh;
    }
  }
}
.online-pay{
  display: flex;
  justify-content: space-between;
  width: 900px;
  margin: 0 auto;
}
.pay-box{
  border: 1px solid #F4F4F5;
  padding: 20px;
  text-align: center;
  width: 170px;
  .wxzf{
    width: 120px;
    height: auto;
  }
}
.pay-tip{
  color: #999;
  font-size: 12px;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.offline-pay{
  width: 400px;
  margin: 0 auto;
}
.person-pay{
  width: 800px;
  margin: 0 auto;
}
.el-button--primary {
  background-color: #b81c25;
  border: 1px solid #b81c25;
  margin-bottom: 0px;
  &:hover{
    background-color: #b81c25;
    border-color: #b81c25;
  }
  span {
    font-family: Microsoft YaHei UI;
    color: #fff;
    font-size: 20px;
    letter-spacing: 1px;
  }
}
.el-button--text {
  color: #b81c25;
  font-size: 14px;
  text-decoration: underline;
}
.top-left-backhome {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 20px;
  top: 20px;
}
.top-left-backTitle {
  // margin-left: 0px;
  color: #b81c25;
  border: 0;
  background-color: white;
}
.login-container {
  position: relative;
}
.footer{
  text-align: center;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 20px;
  font-family: regular;
  font-size: 16px;
  span{
    margin: 0 40px;
  }
}
.center{
}
.steps{
  .back{
    color: #fff;
    background-color: #b81c25;
    border-radius: 32px;
    width: 80px;
    height: 32px;
    text-align: center;
    line-height: 32px;
    font-size: 14px;
    cursor: pointer;
  }
}
.el-button--primary {
  background-color: #b81c25;
  border: 1px solid #b81c25;
  margin: 0 auto 10px;
  display: block;
  &:hover{
    background-color: #b81c25;
    border-color: #b81c25;
  }
  span {
    font-family: Microsoft YaHei UI;
    color: #fff;
    font-size: 20px;
    letter-spacing: 1px;
  }
}
.tips{
  color: #b81c25;
  font-size: 12px;
  font-family: systm;
  margin-top: 20px;
  line-height: 18px;
}
.scan{
  color: #000;
  font-size: 14px;
  text-align: center;
}

.flex{
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.label{
  width: 140px;
  text-align: right;
  font-size: 14px;
  color: #666;
}
.value{
  flex: 1;
  margin-left: 30px;
  font-size: 14px;
  color: #000;
}
.qrCode{
  width: 150px;
  height: 150px;
  display: block;
  margin: 10px auto;
}
.qrCodeLoading{
  color: #b81c25;
  font-size: 16px;
  width: 130px;
  height: 130px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 10px auto;
  i{
    font-size: 20px;
  }
}
.btns{
  margin-top: 20px;
  text-align: center;
  .btn1{
    border-color: #000;
    color: #000;
    border-radius: 40px;
    margin-right: 20px;
    width: 140px;
  }
  .btn2{
    background-color: #b81c25;
    border-bottom: #b81c25;
    border-radius: 40px;
    color: #fff;
    margin-right: 20px;
    width: 140px;
  }
}
.mt-40{
  margin: 40px auto 0;
  width: 600px;
}
.teamNum{
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #606266;
  margin: 20px 0;
  .num{
    color: #b81c25;
    font-size: 16px;
    font-weight: bold;
    margin-left: 12px;
  }
}
.operate{
  display: flex;
  align-items: center;
  i{
    font-size: 20px;
    color: #b81c25;
    margin-left: 20px;
    cursor: pointer;
  }
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 180px;
    height: 180px;
    line-height: 180px;
    text-align: center;
    border: 1px dashed #999;
}

.card{
  background-color: #FFF;
  border-radius: 20px;
  padding: 20px;
  .title{
    color: #000;
    font-family: systh;
    font-size: 16px;
  }
  .en-title{
    color: #000;
    font-family: systh;
    font-size: 8px;
    margin-bottom: 20px;
  }
  .desc-title{
    color: #666;
    font-size: 12px;
    font-family: systm;
    margin-top: 10px;
    margin-bottom: 20px;
  }
}
.mt-30{
  margin-top: 30px;
}

.user-card{
  box-shadow: 0 2px 14px rgba(0, 0, 0, 0.3);
  border-radius: 14px;
  height: 240px;
  margin-bottom: 10px;
  .user-card-title{
    background-color: #C9273A;
    height: 40px;
    color: #fff;
    font-family: systh;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 14px 14px 0 0;
    margin-bottom: 10px;
    position: relative;
    img{
      width: 24px;
      height: 24px;
      margin-right: 10px;
    }
    .remove{
      position: absolute;
      right: 10px;
      top: 10px;
      font-size: 20px;
    }
    span{
      position: absolute;
      right: 10px;
      background-color: #fff;
      color: #b81c25;
      font-size: 12px;
      padding: 4px 10px;
      border-radius: 6px;
    }
  }
}
.file-item-card{
  box-shadow: 0 2px 14px rgba(0, 0, 0, 0.3);
  border-radius: 14px;
  .tit{
    background-color: #C9273A;
    text-align: center;
    padding: 4px 0;
    border-radius: 14px 14px 0 0;
    color: #fff;
    .cn{
      font-size: 14px;
      font-family: systh;
    }
    .en{
      font-size: 10px;
      font-family: systm;
    }
  }
  .desc{
    color: #666;
    font-size: 10px;
    font-family: systm;
    padding: 4px 10px;
    height: 40px;
  }
  .file-upload{
    width: 100%;
    /deep/ .el-upload{
      width: 100%;
    }
  }
  .upload-btn{
    text-align: center;
    border-radius: 14px;
    border: 1px dashed #dcdcdc;
    width: 80%;
    height: 100px;
    margin: 20px auto;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    &:hover{
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    }
    img{
      width: 60px;
      height: 60px;
    }
  }
  .file{
    height: 100px;
    text-align: center;
    margin: 20px auto;
    img{
      width: 60px;
      height: 60px;
    }
    .file-name{
      font-size: 12px;
      color: #000;
      font-family: systm;
      margin-bottom: 10px;
      &:hover{
        color: #b81c25;
      }
    }
  }
}
.pr-20{
  padding-right: 20px;
}
.add-btn{
  background-color: #fff;
  width: 100%;
  height: 240px;
  box-shadow: 0 2px 14px rgba(0, 0, 0, 0.3);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  img{
    width: 100px;
    height: 100px;
  }
}
.submit{
  margin-top: 20px;
  width: 140px;
}
.item{
  margin-bottom: 14px;
  display: flex;
  align-items: center;
  .key{
    color: #606266;
    font-family: systm;
    font-size: 12px;
    border-radius: 20px;
    width: 20px;
    height: 68px;
    border: 1px solid #DCDFE6;
    text-align: center;
    padding: 10px 0;
  }
  .val{
    width: 400px;
    height: 88px;
    background-position: center;
    background-size: cover;
    margin-left: 20px;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #fff;
    .cn{
      font-size: 16px;
      font-family: systh;
    }
    .en{
      font-size: 12px;
      font-family: systh;
    }
  }
  .val2{
    background-image: url(https://cdn.spbcn.org/spbcnWeb/pbl/bg111.png);
  }
  .val1{
    background-image: url(https://cdn.spbcn.org/spbcnWeb/pbl/bg222.png);
  }
}
.item2{
  border: 1px solid #DCDFE6;
  height: 32px;
  line-height: 32px;
  width: 100%;
  border-radius: 32px;
  color: #606266;
  display: flex;
  font-size: 14px;
  font-family: systm;
  margin-bottom: 30px;
  .key{
    width: 60px;
    padding: 0 10px;
    border-right: 1px solid #DCDFE6;
    margin-right: 10px;
  }
  .val{
    color: #000;
  }
}

.info-check{
  width: 100px;
  height: 100px;
  object-fit: contain;
  display: block;
  margin: 40px auto;
  background-color: #b81c25;
  border-radius: 100px;
  padding: 20px;
}
.tip{
  color: #b81c25;
  text-align: center;
  margin-top: 40px;
  font-size: 14px;
  font-family: systh;
}
.entip{
  color: #b81c25;
  text-align: center;
  margin: 10px auto;
  font-size: 10px;
  font-family: systh;
  width: 60%;
}
.page-step{
  top: 20px;
}
.img-detail{
  max-width: 300px;
}
::v-deep .el-input__inner{
  border-radius: 40px;
}
::v-deep .el-textarea__inner{
  border-radius: 14px;
}
.productPrice{
  font-family: systh;
  font-size: 18px;
  color: #b81c25;
  margin-bottom: 20px;
  span{
    color: #606266;
    font-family: systm;
    font-size: 14px;
  }
}
.productName{
  font-family: systh;
  font-size: 18px;
  color: #000;
  margin-bottom: 20px;
  text-align: center;
}
.expand-section{
  width: 100%;
  .expand-title{
    color: #606266;
    font-family: systm;
    font-size: 14px;
    margin-bottom: 10px;
    margin-top: 10px;
  }
}
.default{
  text-align: center;
  color: #999;
  font-size: 12px;
  margin: 40px 0;
}
.text-c{
  font-family: systm;
  font-size: 14px;
  color: #999;
}
.fcode-input{
  width: 60%;
  margin: 20px auto 40px;
  display: block;
  /deep/ .el-input__inner{
    text-align: center;
  }
}
</style>
